export default "__VITE_ASSET__CoLF0vTm__"